import './columnblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'
import {Theme} from 'views/theme'

const styles = style('columnblock')

export type ColumnBlockType = {
	text_left: WysiwygType
	text_right: WysiwygType
}

export const ColumnBlock: FunctionComponent<ColumnBlockType> = ({
	text_left,
	text_right
}) => {
	if (!text_left && !text_right) return
	return (
		<Block class={styles}>
			<div class={styles('column')}>
				<Theme.Wysiwyg>{text_left}</Theme.Wysiwyg>
			</div>
			<div class={styles('column')}>
				<Theme.Wysiwyg>{text_right}</Theme.Wysiwyg>
			</div>
		</Block>
	)
}
